import React, { Component } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { ImageLoader } from 'react-image-and-background-image-fade';
import image from './imageCosmos1.png';

console.log('Закрой консоль!');

const rotating = keyframes`
  from {
    transform: scale(1) rotate(0deg);
  }
  to {
    transform: scale(2) rotate(-360deg);
  }
`;

const ImageSpace = styled.div`
  background-image: url(${image});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: ${({ windowHeight }) => windowHeight && windowHeight}px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  opacity: 0;
  will-change: transform;
  transition: opacity ${({ theme }) => theme.transition.background};

  ${({ loaded }) =>
    loaded &&
    css`
      opacity: 0.2;
      animation: 800s ${rotating} ease infinite alternate;
    `};
`;

class BackgroundImage extends Component {
  render() {
    return (
      <ImageLoader src={image}>
        {({ hasLoaded }) => (
          <ImageSpace
            loaded={hasLoaded}
            windowHeight={this.props.windowHeight}
          />
        )}
      </ImageLoader>
    );
  }
}

export default BackgroundImage;
